var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 33.25C13.7861 33.25 10.6443 32.297 7.97199 30.5114C5.29969 28.7258 3.21689 26.1879 1.98696 23.2186C0.757041 20.2493 0.435237 16.982 1.06225 13.8298C1.68926 10.6776 3.23692 7.78213 5.50952 5.50952C7.78213 3.23692 10.6776 1.68926 13.8298 1.06225C16.982 0.435237 20.2493 0.757041 23.2186 1.98696C26.1879 3.21689 28.7258 5.29969 30.5114 7.97199C32.297 10.6443 33.25 13.7861 33.25 17C33.25 21.3098 31.538 25.443 28.4905 28.4905C25.443 31.538 21.3098 33.25 17 33.25ZM17 3.25001C14.2805 3.25001 11.6221 4.05643 9.36092 5.5673C7.09974 7.07817 5.33737 9.22563 4.29666 11.7381C3.25596 14.2506 2.98366 17.0153 3.51421 19.6825C4.04476 22.3497 5.35432 24.7998 7.27729 26.7227C9.20026 28.6457 11.6503 29.9553 14.3175 30.4858C16.9848 31.0163 19.7494 30.7441 22.2619 29.7034C24.7744 28.6626 26.9218 26.9003 28.4327 24.6391C29.9436 22.3779 30.75 19.7195 30.75 17C30.75 13.3533 29.3014 9.85591 26.7227 7.27729C24.1441 4.69866 20.6467 3.25001 17 3.25001Z",
    fill: "url(#paint0_linear_4466_31701)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 25.75C16.6685 25.75 16.3505 25.6183 16.1161 25.3839C15.8817 25.1495 15.75 24.8315 15.75 24.5V9.5C15.75 9.16848 15.8817 8.85054 16.1161 8.61612C16.3505 8.3817 16.6685 8.25 17 8.25C17.3315 8.25 17.6495 8.3817 17.8839 8.61612C18.1183 8.85054 18.25 9.16848 18.25 9.5V24.5C18.25 24.8315 18.1183 25.1495 17.8839 25.3839C17.6495 25.6183 17.3315 25.75 17 25.75Z",
    fill: "url(#paint1_linear_4466_31701)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 18.25H9.5C9.16848 18.25 8.85054 18.1183 8.61612 17.8839C8.3817 17.6495 8.25 17.3315 8.25 17C8.25 16.6685 8.3817 16.3505 8.61612 16.1161C8.85054 15.8817 9.16848 15.75 9.5 15.75H24.5C24.8315 15.75 25.1495 15.8817 25.3839 16.1161C25.6183 16.3505 25.75 16.6685 25.75 17C25.75 17.3315 25.6183 17.6495 25.3839 17.8839C25.1495 18.1183 24.8315 18.25 24.5 18.25Z",
    fill: "url(#paint2_linear_4466_31701)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4466_31701",
    x1: 0.75,
    y1: 18.0833,
    x2: 33.25,
    y2: 18.0833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF96FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4466_31701",
    x1: 15.75,
    y1: 17.5833,
    x2: 18.25,
    y2: 17.5833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF96FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4466_31701",
    x1: 8.25,
    y1: 17.0833,
    x2: 25.75,
    y2: 17.0833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF96FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenAdd);
export default __webpack_public_path__ + "static/media/token_add.e6496afc325ba2ae7c5a60df0fbc256a.svg";
export { ForwardRef as ReactComponent };